"use client";
import React, { useMemo } from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import { ArticlePageProductCard } from "~/bff/components/ArticlePageProductCard";
import {
  ProductItemProps,
  ProductItem as ProductItemAsReactComponent,
} from "~/bff/components/ProductItem";
import { ProductItem } from "~/bff/types/ProductItem";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { ARTICLE_PRODUCT_CARD_CLASSES } from "./constants";
import { ArticleProductCardContainer } from "./styled";

export const ArticleProductCard: ArticlePageProductCard = ({
  products,
  testAutomationId = "article-page-product-card",
}) => {
  const isSingleProduct = useMemo(() => products?.length === 1, [products?.length]);

  return (
    <ArticleProductCardContainer
      {...getTestAutomationProps(testAutomationId)}
      {...getTestAutomationProps(testAutomationId)}
      id={testAutomationId ?? ""}
    >
      <Container>
        <Grid
          spacing={0}
          container
          sx={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid
            className={ARTICLE_PRODUCT_CARD_CLASSES.grid}
            size={{
              xs: 12,
              md: isSingleProduct ? 8 : 12,
              lg: isSingleProduct ? 6 : 10,
            }}
          >
            {products?.map(
              (
                product:
                  | ProductItem
                  | React.ReactElement<ProductItemProps, ProductItemAsReactComponent>
                  | null
                  | undefined,
                index,
              ) => {
                if (!product) {
                  return null;
                }
                return (
                  <Box
                    key={index}
                    className={ARTICLE_PRODUCT_CARD_CLASSES.productCardBox}
                    id={`article-product-card-${index}`}
                    {...getTestAutomationProps("article-product-card")}
                  >
                    {product as React.ReactNode}
                  </Box>
                );
              },
            )}
          </Grid>
        </Grid>
      </Container>
    </ArticleProductCardContainer>
  );
};
